// ---------------------------------------------------------------------------
// Teacher-Grading module — locale messages.
// Merged into the global i18n instance at bootstrap time.
// ---------------------------------------------------------------------------

export const teacherGradingMessages = {
  'de-AT': {
    teacher_grading: {
      title: 'Noten erfassen',
      subtitle: 'Offene Notenerfassungen für abgeschlossene Prüfungen.',
      empty: 'Keine offenen Notenerfassungen.',
      columns: {
        exam: 'Prüfung',
        exam_date: 'Termin',
        subscriber: 'Student/in',
        action: 'Aktion',
      },
      actions: {
        record: 'Note erfassen',
      },
      my_grades: {
        title: 'Eigene eingereichte Noten',
        empty: 'Noch keine Noten erfasst.',
        columns: {
          exam: 'Prüfung',
          student: 'Student/in',
          score: 'Punkte',
          austrian_grade: 'Note',
          grade_status: 'Status',
          review: 'Review',
          entered_at: 'Erfasst am',
        },
      },
      dialog: {
        title: 'Note erfassen',
        score: 'Erreichte Punkte',
        max_score: 'Maximalpunkte',
        austrian_grade: 'Note (1–5, optional)',
        austrian_grade_hint: 'Leer lassen, um die Note automatisch aus den Punkten abzuleiten.',
        force_failed: 'Als „Nicht genügend" (5) erzwingen',
        notes: 'Anmerkungen',
        is_published: 'Sofort veröffentlichen (Student sieht Note)',
        submit: 'Speichern',
        cancel: 'Abbrechen',
      },
      grade_status: {
        passed: 'Bestanden',
        failed: 'Nicht bestanden',
        pending_review: 'Review ausstehend',
      },
      review_status: {
        pending: 'Offen',
        approved: 'Freigegeben',
        rejected: 'Zurückgewiesen',
      },
      toast: {
        recorded_title: 'Note gespeichert',
        recorded_detail: 'Die Note wurde zur Administrator-Freigabe übermittelt.',
        record_failed_title: 'Speichern fehlgeschlagen',
        record_failed_detail: 'Die Note konnte nicht gespeichert werden.',
      },
      validation: {
        score_required: 'Bitte Punkte angeben.',
      },
    },
  },
  en: {
    teacher_grading: {
      title: 'Record grades',
      subtitle: 'Open grade entries for completed exams.',
      empty: 'No open grade entries.',
      columns: {
        exam: 'Exam',
        exam_date: 'Date',
        subscriber: 'Student',
        action: 'Action',
      },
      actions: {
        record: 'Record grade',
      },
      my_grades: {
        title: 'My submitted grades',
        empty: 'No grades recorded yet.',
        columns: {
          exam: 'Exam',
          student: 'Student',
          score: 'Score',
          austrian_grade: 'Grade',
          grade_status: 'Status',
          review: 'Review',
          entered_at: 'Entered at',
        },
      },
      dialog: {
        title: 'Record grade',
        score: 'Score achieved',
        max_score: 'Max score',
        austrian_grade: 'Grade (1–5, optional)',
        austrian_grade_hint: 'Leave empty to derive the grade automatically from the score.',
        force_failed: 'Force "failed" (5)',
        notes: 'Notes',
        is_published: 'Publish immediately (student sees grade)',
        submit: 'Save',
        cancel: 'Cancel',
      },
      grade_status: {
        passed: 'Passed',
        failed: 'Failed',
        pending_review: 'Review pending',
      },
      review_status: {
        pending: 'Pending',
        approved: 'Approved',
        rejected: 'Rejected',
      },
      toast: {
        recorded_title: 'Grade saved',
        recorded_detail: 'The grade has been submitted for administrator review.',
        record_failed_title: 'Save failed',
        record_failed_detail: 'The grade could not be saved.',
      },
      validation: {
        score_required: 'Please enter a score.',
      },
    },
  },
} as const;
